import * as echarts from 'echarts';
import React, { useEffect, useRef } from 'react';

const GraficoPorRiesgo = ({ datos }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        const chart = echarts.init(chartRef.current, 'light'); // 👈 Tema claro

        const categorias = ['P50', 'P95', 'P99'];
        const series = [];

        const nombreMapeo = {
            'general': 'Total',
            'Degradación / interrupción del servicio': 'Disponibilidad',
            'Manipulación del activo': 'Integridad',
            'Robo / revelación del activo': 'Confidencialidad'
        };

        // Serie General
        const general = datos.general[0];
        series.push({
            name: nombreMapeo['general'],
            type: 'line',
            data: [
                parseInt(general.media),
                parseInt(general.P95),
                parseInt(general.P99)
            ]
        });

        // Series por riesgo
        const riesgos = datos['por riesgo'];
        for (const riesgo in riesgos) {
            const valores = riesgos[riesgo];
            series.push({
                name: nombreMapeo[riesgo] || riesgo,
                type: 'line',
                data: [
                    parseInt(valores.media),
                    parseInt(valores.P95),
                    parseInt(valores.P99)
                ]
            });
        }

        const option = {
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => parseInt(value).toLocaleString()
            },
            legend: {
                type: 'scroll',
                data: series.map(s => s.name)
            },
            xAxis: {
                type: 'category',
                data: categorias
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (value) => parseInt(value).toLocaleString()
                }
            },
            series,
            graphic: [
                {
                    type: 'text',
                    left: 110,
                    top: 5,
                    style: {
                        text: 'MM',
                        fill: '#333',
                        font: 'bold 14px sans-serif'
                    }
                }
            ]
        };


        chart.setOption(option);
        return () => chart.dispose();
    }, [datos]);

    return <div id="main" ref={chartRef} style={{ width: '100%', height: '400px' }} />;
};

export default GraficoPorRiesgo;
